import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAthleteRoleGroups } from '@api/lookups';
import { IAthleteRoleGroup } from '@interfaces/lookups';

export const handleGetAthleteRoleGroups = createAsyncThunk<
  AxiosResponse<IAthleteRoleGroup[]>,
  void
>('getAthleteRoleGroups', getAthleteRoleGroups);
